import { cn } from '@newfront-insurance/core-ui/v2';
import { format, isThisYear, isToday } from 'date-fns';

export function formatMessageTimestamp(createdAt: string): string | undefined {
  const date = new Date(createdAt);

  if (Number.isNaN(date.getTime())) {
    return undefined;
  }

  if (isToday(date)) {
    return format(date, 'h:mm a');
  }

  if (isThisYear(date)) {
    return format(date, 'MMM d, h:mm a');
  }

  return format(date, 'MMM d, yyyy, h:mm a');
}

interface MessageTimestampProps {
  createdAt?: string;
  className?: string;
}

export function MessageTimestamp({ createdAt, className }: MessageTimestampProps) {
  if (!createdAt) {
    return null;
  }

  const label = formatMessageTimestamp(createdAt);

  if (!label) {
    return null;
  }

  return (
    <time
      dateTime={createdAt}
      data-testid="message-timestamp"
      className={cn('text-steel-500 text-sm leading-4 whitespace-nowrap', className)}
    >
      {label}
    </time>
  );
}
